import Backbone from "backbone";
import Parse from "parse";
import FOVIndicator from "../helpers/FOVIndicator";
import SkyObjectObservation from "../helpers/SkyObjectObservation";
import BaseParseObject from "./BaseParseObject";
import StaticEquipment from "./StaticEquipment";

("use strict");

export const Equipment = BaseParseObject.extend("Equipment", {
  initParseACL: function () {
    const acl = new Parse.ACL();

    if (!this.get("ACL")) {
      acl.setPublicReadAccess(false);
      acl.setReadAccess(Parse.User.current().id, true);
      acl.setWriteAccess(Parse.User.current().id, true);
      this.setACL(acl);
    }
  },

  setEquipmentProperties: function (data) {
    const equipmentType = data.type;
    const properties = {};

    switch (equipmentType) {
      case "barlowReducer":
        properties.magnification = data.magnification;
        break;
      case "binoculars":
        properties.fieldOfView = data.fieldOfView;
        properties.aperture = data.aperture;
        properties.magnification = data.magnification;
        break;
      case "camera":
        properties.sensorWidthInPixels = data.sensorWidthInPixels;
        properties.sensorPixelWidth = data.sensorPixelWidth;
        properties.sensorHeightInPixels = data.sensorHeightInPixels;
        properties.sensorPixelHeight = data.sensorPixelHeight;
        properties.sensorOffsetX = data.sensorOffsetX;
        properties.sensorOffsetY = data.sensorOffsetY;
        break;
      case "eyepiece":
        properties.focalLength = data.focalLengthEyepiece;
        properties.apparentFOV = data.apparentFOV;
        break;
      case "telescope":
        properties.aperture = data.aperture;
        properties.focalLength = data.focalLengthTelescope;
        break;
    }

    this.unset("properties");
    this.set("properties", properties);
  },

  setStaticEquipment: function (data) {
    const staticEquipment = StaticEquipment.createWithoutData(
      data.staticEquipmentId,
    );

    if (data.staticEquipmentId) {
      this.set("staticEquipment", staticEquipment);
    } else {
      this.set("staticEquipment", null);
    }
  },

  update: function (data) {
    this.initParseACL();
    this.set("user", Parse.User.current());
    this.set("name", data.name);
    this.set("type", data.type);
    this.set("make", data.make);
    this.setEquipmentProperties(data);
    this.setStaticEquipment(data);

    return this.save().then(
      (item) => {
        Backbone.trigger("equipments:updated", item);
      },
      (error) => {
        Backbone.trigger("errors:parseReturned", error);
      },
    );
  },

  hasLinkedItems: function () {
    var fovIndicatorCount =
      FOVIndicator.getFOVIndicatorsByEquipment(this).length;
    var observationCount =
      SkyObjectObservation.getSkyObjectObservationsByEquipment(this).length;

    return !!(fovIndicatorCount > 0 || observationCount > 0);
  },

  getLinkedItemsMessage: function () {
    const baseMessage = "Cannot delete Equipment. It is still referenced by ";
    let fovMessage = "";
    let observationMessage = "";
    var fovIndicatorCount =
      FOVIndicator.getFOVIndicatorsByEquipment(this).length;
    var observationCount =
      SkyObjectObservation.getSkyObjectObservationsByEquipment(this).length;

    if (fovIndicatorCount > 0) {
      fovMessage =
        fovIndicatorCount === 1
          ? "1 FOV Indicator "
          : `${fovIndicatorCount} fov Indicators `;
    }
    if (observationCount > 0) {
      observationMessage =
        observationCount === 1
          ? " 1 Observation "
          : `${observationCount} Observations `;
    }

    return fovIndicatorCount > 0 && observationCount > 0
      ? `${baseMessage + fovMessage} and ${observationMessage}`
      : baseMessage + fovMessage + observationMessage;
  },

  delete: function () {
    if (this.hasLinkedItems()) {
      const errorMsg = this.getLinkedItemsMessage();
      Backbone.trigger("errors:deleteNotAllowed", errorMsg);
      return Promise.reject(new Error(errorMsg));
    }

    this.set("deleted", true);
    return this.save().then(
      (result) => {
        Backbone.trigger("equipments:deleted", result);
      },
      (error) => {
        Backbone.trigger("errors:parseReturned", error);
      },
    );
  },

  getSortOrder: function () {
    return this.get("sortOrder");
  },

  setSortOrder: function (order) {
    this.set("sortOrder", order);
  },
});

export default Equipment;
